<template>

    <b-row>
      <b-col cols="12">

        <!-- PERMISSION TABLE -->
        <b-card no-body class="border">

          <div v-if="requestPending" class="loading_page" style=" padding: 10px;">
            <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'"/>
          </div>

          <b-card-header class="p-1">
            <b-card-title class="font-medium-2">
              <feather-icon icon="LockIcon" size="18"/>
              <span class="align-middle ml-50">{{ $t('Geofence Permission')}}</span>
            </b-card-title>
          </b-card-header>


          <geofence-filter :contracts-filter.sync="contractsFilter"
                          :contract-options="contractsOptions"
                          :group-filter.sync="groupFilter"
                          :groups-options="groupsOptions"
                          :categories-options="categoriesOptions"
                          :owners-filter.sync="ownersFilter"
                          :categories-filter.sync="categoriesFilter"
                          :owners-options="ownersOptions">

          </geofence-filter>

          <div class="m-2">

            <!-- Table Top -->
            <b-row>
              <!-- Per Page -->
              <b-col cols="12" md="6" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
                <label>{{ $t('Show') }}</label>
                <v-select
                    v-model="perPage"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="perPageOptions"
                    :clearable="false"
                    class="per-page-selector d-inline-block mx-50"
                />
                <label>{{ $t('entries') }}</label>
              </b-col>

              <!-- Search -->
              <b-col cols="12" md="6">
                <div class="d-flex align-items-center justify-content-end">
                  <b-form-input v-model="searchQuery" class="d-inline-block mr-1" :placeholder="$t('Search')"/>
                </div>
              </b-col>
            </b-row>

          </div>
         
          <b-table striped responsive class="mb-0"
                   :items="authGeofence" :fields="fields">

            <template #head(list)="data">
              <b-form-checkbox @change="checkAll(data, $event)" />
            </template>

            <template #cell(name)="data">
              {{ data.value }}
            </template>

            <template #cell()="data">
              <b-form-checkbox :state="userGeofence.includes(data.item.geofence_id) ? true : null" :checked="requestIds.includes(data.item.geofence_id)" @change="change(data, $event)" />
            </template>

          </b-table>

          <div class="mx-2 mb-2">
            <b-row>

              <b-col cols="12" sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-sm-start">
                <span class="text-muted">
                  {{ $t('Showing') }} {{ dataMeta.from }} {{$t('to')}} {{ dataMeta.to }} {{ $t('of')}} {{ dataMeta.of }} {{$t('entries-geofence')}}
                </span>
              </b-col>
              <!-- Pagination -->
              <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">

                <b-pagination
                    v-model="currentPage"
                    :total-rows="totalTable"
                    :per-page="perPage"
                    first-number
                    last-number
                    class="mb-0 mt-1 mt-sm-0"
                    prev-class="prev-item"
                    next-class="next-item"
                >
                  <template #prev-text>
                    <feather-icon
                        icon="ChevronLeftIcon"
                        size="18"
                    />
                  </template>
                  <template #next-text>
                    <feather-icon
                        icon="ChevronRightIcon"
                        size="18"
                    />
                  </template>
                </b-pagination>

              </b-col>

            </b-row>
          </div>

          <div class="mx-2 mb-2">
            <b-row>
              <b-col cols="12" class="mb-2">
                <!-- Action Buttons -->
                <b-button
                    type="submit"
                    variant="primary"
                    class="mb-1 mb-sm-0 mr-0 mr-sm-1"
                    :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                    @click="submit"
                >
                  {{ $t('Save Changes')}}
                </b-button>
              </b-col>
            </b-row>
          </div>

        </b-card>
      </b-col>

    </b-row>
</template>

<script>
import {
  BFormFile,
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BAlert,
  BCard,
  BCardText,
  BMedia,    BPagination,
  BMediaAside,
  BMediaBody,
  BLink,BBadge,
  BImg,
  BTable, BFormCheckbox, BCardTitle, BCardHeader,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ref, computed, watch } from '@vue/composition-api'
import store from '@/store'
import vSelect from 'vue-select'
import permissionsStoreModule from '@/views/modules/user/users-edit/permissions/permissionsStoreModule'
import usePermissions from '@/views/modules/user/users-edit/permissions/usePermissions'
import GeofenceFilter from '@/views/modules/user/users-edit/permissions/GeofenceFilter'
import { OrbitSpinner } from 'epic-spinners'
import filters from '@/views/modules/Utils/filters'
import router from '@/router'
export default {
  components: {
    BButton, BForm, BImg, BFormFile,
    BFormGroup, BFormInput, BRow,
    BCol, BAlert, BCard, BCardText,BBadge,
    BMedia, BMediaAside, BMediaBody, vSelect,BPagination,
    BLink,BTable,BFormCheckbox,  BCardTitle, BCardHeader, GeofenceFilter,
    OrbitSpinner
  },
  directives: {
    Ripple,
  },
  props: {
    user: {
      type: Number,
      required: true
    },
  },

  setup(props, { root, emit }) {

    const requestIds = ref([])
    const changedIds = ref([])
    const current_selected=ref([])
    
   
    const requestPending = ref(false)

    const authGeofence = ref([])
    const userGeofence = ref([])

    const ownersFilter = ref([])
    const groupFilter = ref(null)
    const contractsFilter = ref([])
    const categoriesFilter = ref([])

    const {perPage, perPageOptions, searchQuery, currentPage, totalTable, dataMeta } = usePermissions()

    const filter = ref({})
  ///watch woner option refliter contracts
    const refliterContractByWoners=(owners)=>{          
          let result=contractsOptions_orig.value.filter((i)=>owners.includes(i.contractor_id))         
          contractsOptions.value=result;
           if(owners.length==0){     contractsOptions.value=contractsOptions_orig.value; }         
        }      
    watch([ownersFilter], () => {refliterContractByWoners(ownersFilter.value)})
    watch([currentPage, perPage, searchQuery, contractsFilter, categoriesFilter, groupFilter, ownersFilter], () => {
      filter.value = {
        ...(ownersFilter.value && {owners: ownersFilter.value}),
        ...(searchQuery.value && {q: searchQuery.value}),
        ...(groupFilter.value && {group: groupFilter.value}),
        ...(contractsFilter.value && {contracts: contractsFilter.value}),
        ...(categoriesFilter.value && {categories: categoriesFilter.value})
      }

      fetchAuthGeofence()
    })


    const Geofence_PERMISSION_APP_STORE_MODULE_NAME = 'app-permission'

    if (!store.hasModule(Geofence_PERMISSION_APP_STORE_MODULE_NAME))
            store.registerModule(Geofence_PERMISSION_APP_STORE_MODULE_NAME,
                permissionsStoreModule)

    const fetchAuthGeofence = () => {

      requestPending.value = true
      store.dispatch('app-permission/userGetLinked', {
        length: perPage.value,
        page: currentPage.value,
        user: store.state.auth.userData.id,
        type: 'geofence',
        ...filter.value
      })
      .then(response => {
        requestPending.value = false
        const { total, data } = response.data.data
        totalTable.value = total
        authGeofence.value = data

        })
      .catch(res => { requestPending.value = false })
    }

    fetchAuthGeofence()

    store.dispatch('app-permission/userGetLinkedAlerts', { notificationId: router.currentRoute.params.id, type: 'notificationGeofences' })
      .then(res => {
      
        requestIds.value = res.data.ids
        userDevices.value = res.data.ids
      }).catch(res => { })


    const { ownersOptions, groupsOptions, contractsOptions,contractsOptions_orig, categoriesOptions } = filters('geofence')

    const  fields = ['name','list']


    const submit = () => {
      let requsetData = {
        "type": "notificationGeofences",
        "notificationId": router.currentRoute.params.id,
        "geofences": requestIds.value
      }
      requestPending.value = true
      store.dispatch('alert/attachDevicesToAlert', requsetData)
        .then(res => {
          requestPending.value = false
          toaster('Updated Successfully', 'success', 'success')
        })
    }
    




    const change = (data, value) => {
      const index = requestIds.value.indexOf(data.item.geofence_id);
      if (value && index === -1) requestIds.value.push(data.item.geofence_id)
      else requestIds.value.splice(index, 1)
    }

    const checkAll = (data, value) => {    
      if (value){
        authGeofence.value.map(item => {
          console.log(requestIds.value.indexOf(item.geofence_id))
          if(requestIds.value.indexOf(item.geofence_id) == -1){
              requestIds.value.push(item.geofence_id)
          }   
      })
      requestIds.value.map((v) =>{
      
        if(current_selected.value.indexOf(v) < 0){
          current_selected.value.push(v)
        }
      })
     
    }


    else{
      authGeofence.value.map(item => {        
        const index = current_selected.value.indexOf(item.geofence_id)    
    
        if (index !== -1) current_selected.value.splice(index, 1)
      })
    }
 requestIds.value=[]
 requestIds.value=current_selected.value;
    }


    const toaster = (msg, variant, title) => {
      root.$root.$bvToast.toast(msg, {
        title,
        variant,
        solid: true,
      })
    }

    return {
      authGeofence,
      userGeofence,
      perPage,
      perPageOptions,
      currentPage,
      searchQuery,
      totalTable,
      dataMeta,
      change,
      fields,
      checkAll,
      submit,
      fetchAuthGeofence,
      ownersOptions,
      contractsOptions,
      categoriesOptions,
      groupsOptions,
      ownersFilter,
      groupFilter,
      categoriesFilter,
      contractsFilter,
      requestIds,
      requestPending,
      current_selected
    }
  },
}
</script>
